import { Omit, Partial } from '@40seas/entities/common';
import { BaseEntityFieldsArray } from '@40seas/models';
import { Attachment } from './attachment.entity';

export class UpdateAttachmentDto extends Partial(Omit(Attachment, [...BaseEntityFieldsArray])) {}
